<template>
  <div class="container">
    <div v-show="!authenticated">
      <p class="h3 mt-4 text-center">Please Login And Try Again</p>
    </div>
    <div v-show="authenticated">
      <div class="row justify-content-md-center">
        <div class="col-sm-auto col-md-4 col-lg-5">
          <p class="h3 mt-4 text-center">Upload Album</p>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-auto col-md-4 col-lg-5 p-4">
          <b-form
            @submit="onSubmit"
            @reset="onReset"
            v-if="show"
            ref="albumData"
          >
            <b-form-group
              id="input-group-1"
              label="Email address:"
              label-for="input-1"
              description="We'll never share your email with anyone else."
            >
              <b-form-input
                id="input-1"
                v-model="form.email"
                type="email"
                required
                placeholder="Enter email"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-2"
              label="Client Name:"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.clientName"
                required
                placeholder="Enter name"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-3"
              label="Upload Client Photos:"
              label-for="input-3"
            >
              <b-form-file
                v-model="form.album"
                :state="Boolean(form.album)"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                accept=".zip"
                required
              ></b-form-file>
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              class="mr-4"
            >Submit</b-button>
            <b-button
              type="reset"
              variant="danger"
            >Reset</b-button>
            <b-modal
              size="sm"
              ref="print-confirm"
              centered
              title="Success"
              @ok="handlePrint"
              ok-only
            >
              <div class="d-block text-center">
                <h6>
                  Sharable Link
                  <span class="font-weight-bold text-success">{{shortUrl}}</span>
                </h6>
              </div>
            </b-modal>
            <b-modal
              size="sm"
              ref="options-confirm"
              centered
              title="Choose"
            >
              <div class="d-block text-center">
                <h6>
                  This will remove the Album permanantly, Do you want to Proceed?
                </h6>
              </div>
              <template v-slot:modal-footer>
                <b-button-group
                  class="float-right"
                  size="sm"
                >
                  <b-button
                    variant="info"
                    class="mr-3"
                    @click="handleDelete()"
                  >Delete</b-button>
                  <b-button
                    variant="danger"
                    @click="handleCancel"
                  >Cancel</b-button>
                </b-button-group>
              </template>
            </b-modal>
            <b-modal
              ref="progress"
              hide-header="true"
              hide-footer="true"
              centered
              no-close-on-backdrop
              data-keyboard="false"
            >
              <div class="text-center">
                <b-progress
                  v-if="progressInd"
                  :value="progress"
                  variant="success"
                  :striped="notDone"
                  animated
                  show-progress
                ></b-progress>
              </div>
            </b-modal>
          </b-form>
          <!-- <b-card class="mt-3" header="Form Data Result">
        <pre class="m-0">{{ form }}</pre>
          </b-card>-->
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div
          class="col-md-2 col-lg-3 col-sm-1 mb-4 text-center"
          v-for="upload in uploads"
          v-bind:key="upload.email"
        >
          <b-button
            pill
            size="lg"
            class="scale-on-hover folder"
            @click="showOptionsConfirm(upload.email)"
          >
            <b-icon
              icon="images"
              font-scale="6"
              style="color:rgba(0, 111, 25, 0.89);"
            ></b-icon>
          </b-button>
          <br />
          <b-badge
            variant="info"
            pill
          >{{upload.email}}</b-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      form: {},
      show: true,
      shortUrl: '',
      progress: 0,
      progressInd: false,
      notDone: true,
      uploads: [],
      deleteAlbum: '',
      authenticated: false
    }
  },
  methods: {
    onSubmit (evt) {
      this.$refs['progress'].show()
      evt.preventDefault()
      var self = this
      /* formData */
      var formData = new FormData()
      formData.append('album', this.form.album, this.form.album.name)
      formData.append('email', this.form.email)
      formData.append('clientName', this.form.clientName)
      this.progressInd = true
      /* AJAX request */

      axios
        .post('photos', formData, {
          onUploadProgress: progressEvent => {
            self.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
          },
          crossdomain: true
        })
        .then(response => {
          self.notDone = false
          self.shortUrl = response.data
          this.$refs['progress'].hide()
          this.$refs['print-confirm'].show()
        })

      /* axios({
                method: "post",
                url: "http://localhost:8080/photos",
                crossdomain: true,
                data: formData,
                config: { headers: { "Content-Type": "multipart/form-data"}}

            })
            .then(response => {
                self.shortUrl=response.data
                this.$refs['print-confirm'].show()
            }) */
    },
    showPrintConfirm () {
      this.$refs['print-confirm'].show()
    },
    showOptionsConfirm (email) {
      this.deleteAlbum = email
      this.$refs['options-confirm'].show()
    },
    handleCancel () {
      this.$refs['options-confirm'].hide()
    },
    handlePrint () {
      // this.$refs['print-confirm'].close();
      this.$bvToast.toast('Album Creation Successful', {
        title: 'Success',
        variant: 'success',
        toaster: 'b-toaster-top-center',
        solid: true
      })
      this.onReset()
      this.loadAlbums()
    },
    handleDelete () {
      axios
        .delete('photos/' + this.deleteAlbum)
        .then(response => {
          this.handleCancel()
          this.$bvToast.toast('Album Deletion Successful', {
            title: 'Success',
            variant: 'success',
            toaster: 'b-toaster-top-center',
            solid: true
          })
          this.loadAlbums()
        })
    },
    onReset () {
      this.form.email = ''
      this.form.clientName = ''
      this.form.food = null
      this.form.checked = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    loadAlbums () {
      axios.get('photos').then(response => {
        this.uploads = response.data
      })
    }
  },
  mounted () {
    if (!this.$cookies.get('zic-login')) {
      this.authenticated = false
    } else {
      this.authenticated = true
    }
    this.loadAlbums()
  }
}
</script>

<style scoped>
.folder:hover,
.folder:focus,
.folder:active {
  background-color: #a08d02b8 !important; /*#007bff*/
}
.folder {
  background-color: #fdde054a !important; /*#007bff*/
}

.scale-on-hover:hover {
  transform: scale(1.05);
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.15) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminUpload.vue